import imageCompression from "browser-image-compression";

const MAX_ORIGINAL_BYTES = 30 * 1024 * 1024;
const MAX_UPLOAD_BYTES = 3 * 1024 * 1024;
const FORMATS = new Set(["image/jpeg", "image/png", "image/webp"]);

export async function prepareVisitPhoto(file, onProgress) {
  if (file.size > MAX_ORIGINAL_BYTES) throw new Error("La foto supera los 30 MB admitidos.");
  const extension = file.name.split(".").pop()?.toLowerCase();
  const inferred = { jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png", webp: "image/webp" }[extension];
  const mime = file.type || inferred;
  if (!FORMATS.has(mime)) throw new Error("Formato no compatible. Adjunta una foto JPG, PNG o WebP.");
  const input = file.type ? file : new File([file], file.name, { type: mime });
  // Allow the pending progress UI to paint before mobile canvas work begins.
  await new Promise((resolve) => setTimeout(resolve, 0));
  let compressed;
  try {
    compressed = await imageCompression(input, {
      maxSizeMB: 3, maxWidthOrHeight: 2400, initialQuality: 0.92, maxIteration: 1,
      alwaysKeepResolution: true,
      fileType: "image/jpeg", preserveExif: false,
      // No remote worker/CDN dependency: the library is part of our own bundle.
      useWebWorker: false, onProgress,
    });
    // Avoid repeatedly degrading a small PNG merely because JPEG is larger
    // than its original. Only run further quality passes over our size budget.
    if (compressed.size > MAX_UPLOAD_BYTES) {
      compressed = await imageCompression(compressed, {
        maxSizeMB: 3, maxWidthOrHeight: 2400, initialQuality: 0.88, maxIteration: 8,
        fileType: "image/jpeg", preserveExif: false, alwaysKeepResolution: true,
        useWebWorker: false, onProgress,
      });
    }
  } catch {
    throw new Error("No se pudo preparar esta imagen. El archivo puede estar dañado o no ser compatible.");
  }
  if (!compressed.size || compressed.size > MAX_UPLOAD_BYTES) throw new Error("No se pudo reducir la foto al tamaño de carga permitido.");
  return new File([compressed], `${file.name.replace(/\.[^.]+$/, "") || "foto"}.jpg`, { type: "image/jpeg" });
}

export function photoUploadError(error) {
  const status = error?.response?.status;
  if (status >= 500 || error?.code === "ECONNABORTED" || error?.code === "ERR_NETWORK") {
    return "No pudimos confirmar la carga por un problema de conexión o del servidor. Revisa las fotos guardadas antes de volver a intentarlo.";
  }
  if (typeof error?.response?.data?.detail === "string") return error.response.data.detail;
  return error?.message || "No se pudo adjuntar la foto.";
}